import { baseURL, oauthPrefix } from './Config'
import axios from 'axios'
import { axiosClient } from './AxiosClient'
import dayjs from 'dayjs'

const taskStatus = {
    CREATE: "CREATE",
    WAITING: "WAITING",
    IN_PROGRESS: "IN_PROGRESS",
    COMPLETE: "COMPLETE",
    CANCEL: "CANCEL"
}

function listTask(page, size , status, startDate, endDate, repairTypeId, companyId, isExport, callback, errorCallback){
    let url = "/task";

    var params = {
        page: page,
        size: size,
        isExport: isExport,
        building_id: localStorage.getItem('building_id')
    }

    if(status !== "ALL"){
        params["status"] = status
    }

    if(startDate !== null){
        params["start"] = dayjs(startDate).format("YYYY/MM/DD")
    }

    if(endDate !== null){
        params["end"] = dayjs(endDate).format("YYYY/MM/DD")
    }

    if(repairTypeId !== ""){
        params["repairTypeId"] = repairTypeId
    }

    if(companyId !== ""){
        params["companyId"] = companyId
    }

    axiosClient.get(url, {
        params: params
    })
    .then((response)=>{
        callback(response.data)
        console.log(response.data)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function listRepairType(callback, errorCallback){
    let url = "/dropDrown/repairType"

    axiosClient.get(url)
    .then((response)=>{
        let data = response.data
        callback(data)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function listIssuetype(repairTypeId, callback, errorCallback){
    let url = "/dropDrown/issueType"
    var query = { repairTypeId: repairTypeId }

    axiosClient.get(url, {
        params: query
    })
    .then((response)=>{
        let data = response.data
        callback(data)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function createService(repairTypeId, issueTypeId, room, quantity, telephone, remark, floor, zone, officePhone, callback, errorCallback){
    let url = "/maintenance"

    let sRoom = ""
    let sTelephone = ""
    let sQuantity = "0"

    if(issueTypeId >= 1 && issueTypeId <= 4){
        sRoom = room
        sQuantity = quantity
    }else if(issueTypeId === "8"){
        sTelephone = telephone
    }else if ((issueTypeId >= 14 && issueTypeId <= 20) || (issueTypeId >= 26 && issueTypeId <= 28)){
        sRoom = room
    }else if(issueTypeId === "21"){
        sQuantity = quantity
        sRoom = room
    }else if(issueTypeId === "25"){
        sQuantity = quantity
        sRoom = room
    }

    var bodyData = {
        repairTypeId: repairTypeId,
        issueTypeId: issueTypeId,
        room: sRoom,
        quantity: sQuantity,
        telephone: sTelephone,
        remark: remark,
        floor: floor,
        zone: zone,
        officePhone: officePhone
    }

    axios.post(url, bodyData, {
        baseURL: baseURL,
        headers:{
            "Content-Type": "application/json",
            "Authorization": oauthPrefix + localStorage.getItem("access_token")
        }
    })
    .then((response)=>{
        callback(response.data)
    })
    .catch((error)=>{
        errorCallback(error)
    })

}

function addImageMaintenance(imageId, imagePath, callback, errorCallback){
    let url = "/maintenance/addImage/" + imageId

    axios({
        url: url,
        baseURL: baseURL,
        method: 'POST',
        data: imagePath,
        headers:{
            "Authorization": oauthPrefix + localStorage.getItem("access_token"),
            "Content-Type": "application/json"
        }
    })
    .then((response)=>{
        console.log(response)
        callback(response)
    })
    .catch((error)=>{
        console.log(error.response)
        errorCallback(error)
    })
    
}

function listServiceStatus(page, size, callback, errorCallback){
    let url = "/maintenance"
    var query = {
        page: page,
        size: size
    }
    axiosClient.get(url, {
        params: query
    })
    .then((response)=>{
        let data = response.data
        callback(data)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function listHistoryStatus(page, size, callback, errorCallback){
    let url = "/maintenance/history"
    var query ={
        page: page,
        size: size
    }

    axiosClient.get(url, {
        params: query
    })
    .then((response)=>{
        let data = response.data
        callback(data)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function taskDetail(taskId, callback, errorCallback){
    let url = "/task/"+taskId

    axiosClient.get(url)
    .then((response)=>{
        let data = response.data
        callback(data)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function listTechnician(callback, errorCallback){
    let url = "/task/technician";

    axiosClient.get(url)
    .then((response)=>{
        callback(response.data)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function assignTechnician(technicianId, taskId, callback, errorCallback){
    let url = "/task/assign";

    var bodyForm = new FormData()
    bodyForm.append("technicianId", technicianId)
    bodyForm.append("userMaintenanceId", taskId)

    axiosClient.put(url, bodyForm)
    .then((response)=>{
        callback(response.data)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function cancelTask(taskId, callback, errorCallback){
    let url = "/task/cancel/"+taskId;

    axiosClient.post(url)
    .then((response)=>{
        callback(response.data)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function deleteTask(taskId, callback, errorCallback){
    let url = "/maintenance/"+taskId;

    axiosClient.delete(url)
    .then((response)=>{
        callback(response.data)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function unassign(taskId, callback, errorCallback){
    let url = "/task/assign/" + taskId

    axiosClient.delete(url)
    .then((response)=>{
        callback(response.data)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function getPdf(taskId, callback, errorCallback){
    let url = "/task/getPdf";

    axiosClient.get(url,{
        params:{
            userMaintenanceId: taskId
        }
    })
    .then((response)=>{
        let pdfPath = baseURL + response.data.path
        console.log('pdfPath : ',pdfPath)
        callback(pdfPath)
    })
    .catch((error)=>{
        console.log(error)
        errorCallback(error)
    })
}

function getRefresh(callback, errorCallback){
    let url = "/task/refreshTask"
    axiosClient.get(url)
    .then((response)=>{
        let data = response.data
        callback(data)
    })
    .catch((error)=>{
        console.log(error.response)
        errorCallback(error)
    })
}

function addRefresh(status, callback, errorCallback){
    let url = "/task/refreshTask/add"

    var bodyForm = new FormData()
    bodyForm.append("is_refresh", status)

    axiosClient.post(url, bodyForm)
    .then((response)=>{
        callback(response.data)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function updateRefresh(status, callback, errorCallback){
    let url = "/task/refreshTask/update"

    var bodyForm = new FormData()
    bodyForm.append("is_refresh", status)

    axiosClient.post(url, bodyForm)
    .then((response)=>{
        callback()
    })
    .catch((error)=>{
        errorCallback(error)
    })
}


export { 
    listTask, 
    listRepairType,
    listIssuetype,
    listServiceStatus,
    listHistoryStatus,
    taskDetail, 
    listTechnician, 
    assignTechnician, 
    cancelTask, 
    deleteTask, 
    getPdf, 
    unassign, 
    taskStatus, 
    getRefresh,
    addRefresh,
    updateRefresh,
    createService,
    addImageMaintenance
}